
import React from "react";
import { PostSection } from "@/components/blog/PostSection";

export function LimitacionesSection() {
  return (
    <PostSection id="limitaciones" title="Lo que el vibe coding no resuelve">
      <p className="text-gray-300 mb-6">
        Sería deshonesto presentar esto como una solución mágica sin matices.
      </p>

      <h3 id="criterio-negocio" className="text-xl font-semibold text-white mt-4 mb-4">
        Criterio de negocio
      </h3>
      <p className="text-gray-300 mb-6">
        El vibe coding no sustituye el criterio de negocio. Una mala idea construida rápido sigue siendo una mala idea. La velocidad de construcción amplifica tanto los aciertos como los errores de concepto.
      </p>

      <h3 id="escalabilidad" className="text-xl font-semibold text-white mt-8 mb-4">
        Escalabilidad y mantenimiento
      </h3>
      <ul className="list-disc pl-5 text-gray-300 space-y-3 mb-6">
        <li>
          <strong className="text-white">Calidad del código:</strong> Para proyectos que van a escalar a miles de usuarios, en algún punto necesitarás revisar la arquitectura con alguien que entienda de rendimiento y seguridad. El vibe coding es excelente para lanzar; para escalar hay que ser más cuidadoso.
        </li>
        <li>
          <strong className="text-white">Mantenimiento:</strong> Cuando la aplicación crece y necesitas cambios complejos, la coherencia del código generado en múltiples sesiones puede ser un reto. Es manejable, pero requiere disciplina en cómo se documentan los cambios.
        </li>
        <li>
          <strong className="text-white">SEO por defecto:</strong> El vibe coding no sabe de SEO por defecto. Si no le indicas explícitamente cómo estructurar las URLs, qué metadatos generar, cómo manejar el renderizado para que Google lo pueda indexar correctamente, el resultado será técnicamente funcional pero sin visibilidad en búsqueda.
        </li>
      </ul>
    </PostSection>
  );
}
